import React from "react";
import abstract_1 from "../Static/wptm2025-paper1.pdf";
import abstract_2 from "../Static/wptm2025-paper2.pdf";
import abstract_3 from "../Static/wptm2025-paper3.pdf";

export default function Agenda(props) {

    return (
        <div>
          <table style={{border: 'solid 1px #990099', width: '100%' }}>
            <thead style={{borderBottom: 'solid 2px #990099'}}>
              <th>Time (PST)</th>
              <th>Activity</th>
            </thead>
            <tr>
              <td><b>02:00-02:05</b></td>
              <td><b>Introduction and welcome</b></td>
            </tr>
            <tr>
              <td><b>02:05-02:45</b></td>
              <td><b>Keynote and Q&amp;A</b>
                <br></br>
                Matthew J. Coles, Distinguished Member of Technical Staff, Dell Technologies
                <br></br>
                Co-author of <i>Threat Modeling: A Practical Guide for Development Teams</i>
              </td>
            </tr>
            <tr>
              <td><b>02:50-3:15</b></td>
              <td><b>Threat model updates</b>
                  <br></br>
                  02:50-03:00 LINDDUN
                  <br></br>
                  03:00-03:10 UsersFirst
                  <br></br>
                  03:10-03:15 MITRE PANOPTIC™
              </td>
            </tr>
            <tr>
              <td><b>03:20-04:20</b></td>
              <td><b>Presentations and Q&amp;A</b>
                <br></br>
                03:20-03:40 &nbsp; 
                <a className="link" href={abstract_1} download="Beyond-Security.pdf">Opeyemi Ajibuwa, "Beyond Security: A Privacy-Centric Threat Model for Autonomous AI Agents”</a>
                <br></br>
                03:40-04:00 &nbsp; 
                <a className="link" href={abstract_2} download="Privacy-Threat-Modeling-for-AI-User-Journeys.pdf">Sri Pravallika Maddipati  and Srinivas Jantali, "Privacy Threat Modeling for AI User Journeys: Approach and Learnings”</a>
                <br></br>
                04:00-04:20 &nbsp;  
                <a className="link" href={abstract_3} download="Bridging-the-Gap.pdf">Stephen Meyers and Geoﬀrey Golliher, “Bridging the Gap: Applying Threat Intelligence Models to Digital Privacy Threats”</a>
              </td>
            </tr>
            <tr>
              <td><b>04:20-04:35</b></td>
              <td><b>Break</b></td>
            </tr>
            <tr>
              <td><b>04:35-05:55</b></td>
              <td><b>Group Discussion: Integration of privacy threat modeling into broader privacy risk management processes</b></td>
            </tr>
            <tr>
              <td><b>05:55-06:00</b></td>
              <td><b>Closing remarks</b></td>
            </tr>
          </table>
        </div>
    )
}